(function () {
    if (window.PriceDynamicDiscount) {
      window.PriceDynamicDiscount.init();
      return;
    }

    var listenersBound = false;
    var observedVariantInputs = [];
    var variantInputObserver = null;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number == null) {
        return '0';
      }

      var parts = (number / 100).toFixed(precision).split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);

      return parts.join(decimal);
    }

    function formatMoney(cents, format) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, format);
      }

      var formatString = format || ('$' + '{' + '{amount}' + '}');
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var match = formatString.match(placeholderRegex);
      var placeholder = match ? match[1] : 'amount';
      var value;

      switch (placeholder) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'", '.');
          break;
        default:
          value = formatWithDelimiters(cents, 2);
      }

      return formatString.replace(placeholderRegex, value);
    }

    function formatMoneyWithoutTrailingZeros(cents, format) {
      var formatted = formatMoney(cents, format);

      if (Number(cents || 0) % 100 !== 0) {
        return formatted;
      }

      return String(formatted).replace(/([.,])00(?!\d)/, '');
    }

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function getVariantData(component) {
      if (component._priceDynamicVariants) {
        return component._priceDynamicVariants;
      }

      var dataNode = component.querySelector('[data-price-dynamic-variants]');
      if (!dataNode) {
        component._priceDynamicVariants = [];
        return component._priceDynamicVariants;
      }

      try {
        component._priceDynamicVariants = JSON.parse(dataNode.textContent);
      } catch (error) {
        component._priceDynamicVariants = [];
      }

      return component._priceDynamicVariants;
    }

    function findVariant(component, variantId) {
      if (!variantId) {
        return null;
      }

      var variants = getVariantData(component);
      var normalizedId = String(variantId);

      for (var i = 0; i < variants.length; i += 1) {
        if (String(variants[i].id) === normalizedId) {
          return variants[i];
        }
      }

      return null;
    }

    function updateComponent(component, variant) {
      if (!component || !variant) {
        return;
      }

      var price = Number(variant.price || 0);
      var comparePrice = Number(variant.compare_at_price || 0);
      var moneyFormat = component.getAttribute('data-money-format');
      var saleNode = component.querySelector('[data-price-sale]');
      var compareNode = component.querySelector('[data-price-compare]');
      var badgeNode = component.querySelector('[data-price-badge]');
      var taxNode = component.querySelector('[data-price-tax-note]');
      var hasVisibleCompare = comparePrice > price;

      component.setAttribute('data-current-variant-id', variant.id);

      if (component.getAttribute('data-pagefly-mode') !== 'true') {
        component.removeAttribute('data-price-pending');
      }

      if (saleNode) {
        saleNode.innerHTML = formatMoneyWithoutTrailingZeros(price, moneyFormat);
      }

      if (compareNode) {
        if (hasVisibleCompare) {
          compareNode.innerHTML = formatMoneyWithoutTrailingZeros(comparePrice, moneyFormat);
          compareNode.hidden = false;
        } else {
          compareNode.hidden = true;
        }
      }

      if (badgeNode) {
        var saveAmount = comparePrice - price;
        if (saveAmount > 0) {
          badgeNode.innerHTML =
            escapeHtml(component.getAttribute('data-save-label')) +
            ' ' +
            formatMoneyWithoutTrailingZeros(saveAmount, moneyFormat);
        } else {
          badgeNode.textContent = component.getAttribute('data-fallback-label') || '';
        }
      }

      if (hasVisibleCompare && taxNode && taxNode.textContent.trim() && badgeNode) {
        component.setAttribute('data-price-stacked-badge', '');
      } else {
        component.removeAttribute('data-price-stacked-badge');
      }
    }

    function updateByVariantId(variantId) {
      if (!variantId) {
        return false;
      }

      var updated = false;
      var components = document.querySelectorAll('[data-price-dynamic-discount]');

      for (var i = 0; i < components.length; i += 1) {
        var pageFlyDefaultVariantId = getPageFlyDefaultVariantId(components[i]);
        var shouldKeepPageFlyDefault =
          components[i].getAttribute('data-pagefly-mode') === 'true' &&
          components[i].getAttribute('data-pagefly-user-interacted') !== 'true' &&
          pageFlyDefaultVariantId &&
          String(variantId) !== String(pageFlyDefaultVariantId);

        if (shouldKeepPageFlyDefault) {
          continue;
        }

        var variant = findVariant(components[i], variantId);
        if (variant) {
          updateComponent(components[i], variant);
          updated = true;
        }
      }

      return updated;
    }

    function updateComponentByVariantId(component, variantId) {
      var variant = findVariant(component, variantId);
      if (!variant) {
        return false;
      }

      updateComponent(component, variant);
      return true;
    }

    function getPageFlyDefaultVariantId(component) {
      if (!component || !component.closest) {
        return null;
      }

      var productBox = component.closest('[data-default-variant]');
      return productBox ? productBox.getAttribute('data-default-variant') : null;
    }

    function getScopedFormVariantId(component) {
      if (!component || !component.closest) {
        return null;
      }

      var scope =
        component.closest('[data-default-variant]') ||
        component.closest('form[action*="/cart/add"], form[data-product-form], product-form form');

      if (!scope) {
        return null;
      }

      var input = scope.querySelector('[name="id"]');
      return input && input.value ? input.value : null;
    }

    function syncPageFlyComponent(component) {
      var variantId;

      if (component.getAttribute('data-pagefly-user-interacted') === 'true') {
        variantId = getScopedFormVariantId(component) || getPageFlyDefaultVariantId(component);
      } else {
        variantId = getPageFlyDefaultVariantId(component) || getScopedFormVariantId(component);
      }

      return updateComponentByVariantId(component, variantId);
    }

    function getVariantIdFromUrl() {
      try {
        return new URL(window.location.href).searchParams.get('variant');
      } catch (error) {
        return null;
      }
    }

    function getVariantIdFromDetail(detail) {
      if (!detail) {
        return null;
      }

      var candidates = [
        detail.variant && detail.variant.id,
        detail.variant && detail.variant.variant_id,
        detail.selectedVariant && detail.selectedVariant.id,
        detail.productVariant && detail.productVariant.id,
        detail.variantId,
        detail.id
      ];

      for (var i = 0; i < candidates.length; i += 1) {
        if (candidates[i]) {
          return candidates[i];
        }
      }

      return null;
    }

    function getDirectVariantIdFromTarget(target) {
      if (!target) {
        return null;
      }

      if (target.name === 'id' && target.value) {
        return target.value;
      }

      var variantNode = target.closest && target.closest('[data-variant-id]');
      if (variantNode) {
        return variantNode.getAttribute('data-variant-id');
      }

      return null;
    }

    function getFormVariantIdFromTarget(target) {
      if (!target || !target.closest) {
        return null;
      }

      var form = target.closest && target.closest('form[action*="/cart/add"], form[data-product-form], product-form form');
      if (!form) {
        return null;
      }

      var idInput = form.querySelector('[name="id"]');
      return idInput && idInput.value ? idInput.value : null;
    }

    function isPotentialVariantTarget(target) {
      if (!target || !target.closest) {
        return false;
      }

      return Boolean(
        target.closest(
          '[data-variant-id], variant-selects, variant-radios, [data-variant-picker], [data-product-option], [data-option-value], [data-single-option-selector], form[action*="/cart/add"], form[data-product-form], product-form form'
        )
      );
    }

    function syncFromFormsAndUrl() {
      var urlVariantId = getVariantIdFromUrl();
      if (urlVariantId) {
        updateByVariantId(urlVariantId);
      }

      var inputs = document.querySelectorAll(
        'form[action*="/cart/add"] [name="id"], form[data-product-form] [name="id"], product-form form [name="id"]'
      );

      for (var i = 0; i < inputs.length; i += 1) {
        if (inputs[i].value) {
          updateByVariantId(inputs[i].value);
        }
      }
    }

    function observeVariantInputs() {
      if (!window.MutationObserver) {
        return;
      }

      if (!variantInputObserver) {
        variantInputObserver = new MutationObserver(function (mutations) {
          for (var i = 0; i < mutations.length; i += 1) {
            if (mutations[i].target && mutations[i].target.value) {
              updateByVariantId(mutations[i].target.value);
            }
          }
        });
      }

      var inputs = document.querySelectorAll(
        'form[action*="/cart/add"] [name="id"], form[data-product-form] [name="id"], product-form form [name="id"]'
      );

      for (var i = 0; i < inputs.length; i += 1) {
        if (observedVariantInputs.indexOf(inputs[i]) === -1) {
          observedVariantInputs.push(inputs[i]);
          variantInputObserver.observe(inputs[i], {
            attributes: true,
            attributeFilter: ['value']
          });
        }
      }
    }

    function syncFromTarget(target) {
      var delayedVariantId = getDirectVariantIdFromTarget(target) || getFormVariantIdFromTarget(target);
      if (delayedVariantId) {
        updateByVariantId(delayedVariantId);
      }
    }

    function scheduleSync(variantId, target, useGlobalFallback) {
      if (variantId) {
        window.setTimeout(function () {
          updateByVariantId(variantId);
        }, 0);
      }

      if (target && isPotentialVariantTarget(target)) {
        window.setTimeout(function () {
          syncFromTarget(target);
        }, 80);
        window.setTimeout(function () {
          syncFromTarget(target);
        }, 250);
      } else if (useGlobalFallback) {
        window.setTimeout(syncFromFormsAndUrl, 80);
        window.setTimeout(syncFromFormsAndUrl, 250);
      }
    }

    function handleVariantEvent(event) {
      var variantId = getVariantIdFromDetail(event.detail);
      scheduleSync(variantId, null, !variantId);
    }

    function markPageFlyUserInteraction(target) {
      if (!target || !target.closest || !isPotentialVariantTarget(target)) {
        return;
      }

      var scope = target.closest('[data-default-variant]');
      if (!scope) {
        return;
      }

      var components = scope.querySelectorAll('[data-price-dynamic-discount]');
      for (var i = 0; i < components.length; i += 1) {
        components[i].setAttribute('data-pagefly-user-interacted', 'true');
      }
    }

    function handleChangeOrClick(event) {
      markPageFlyUserInteraction(event.target);
      var variantId = getDirectVariantIdFromTarget(event.target);
      scheduleSync(variantId, event.target, false);
    }

    function patchHistory() {
      if (!window.history || window.history.__priceDynamicDiscountPatched) {
        return;
      }

      ['pushState', 'replaceState'].forEach(function (method) {
        var original = window.history[method];
        window.history[method] = function () {
          var result = original.apply(this, arguments);
          window.setTimeout(syncFromFormsAndUrl, 0);
          return result;
        };
      });

      window.history.__priceDynamicDiscountPatched = true;
    }

    function bindListeners() {
      if (listenersBound) {
        return;
      }

      var variantEvents = [
        'variant:change',
        'variant:changed',
        'variantChange',
        'variant-change',
        'product:variant-change',
        'product:variantChange'
      ];

      for (var i = 0; i < variantEvents.length; i += 1) {
        document.addEventListener(variantEvents[i], handleVariantEvent, true);
      }

      document.addEventListener('change', handleChangeOrClick, true);
      document.addEventListener('click', handleChangeOrClick, true);
      document.addEventListener('shopify:section:load', function () {
        window.PriceDynamicDiscount.init();
      });
      window.addEventListener('popstate', syncFromFormsAndUrl);

      patchHistory();
      observeVariantInputs();
      observeDynamicComponents();
      listenersBound = true;
    }

    function observeDynamicComponents() {
      if (!window.MutationObserver || window.PriceDynamicDiscount._componentObserver) {
        return;
      }

      window.PriceDynamicDiscount._componentObserver = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i += 1) {
          for (var j = 0; j < mutations[i].addedNodes.length; j += 1) {
            var node = mutations[i].addedNodes[j];
            if (!node || node.nodeType !== 1) {
              continue;
            }

            if (
              (node.matches && node.matches('[data-price-dynamic-discount]')) ||
              (node.querySelector && node.querySelector('[data-price-dynamic-discount]'))
            ) {
              window.PriceDynamicDiscount.init();
              return;
            }
          }
        }
      });

      window.PriceDynamicDiscount._componentObserver.observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    }

    function init() {
      var components = document.querySelectorAll('[data-price-dynamic-discount]');

      for (var i = 0; i < components.length; i += 1) {
        if (!components[i].getAttribute('data-price-dynamic-ready')) {
          components[i].setAttribute('data-price-dynamic-ready', 'true');
          getVariantData(components[i]);
        }

        if (getPageFlyDefaultVariantId(components[i])) {
          syncPageFlyComponent(components[i]);
        }
      }

      bindListeners();
      observeVariantInputs();

      for (var j = 0; j < components.length; j += 1) {
        if (
          components[j].getAttribute('data-pagefly-mode') === 'true' &&
          !components[j].getAttribute('data-pagefly-sync-started')
        ) {
          components[j].setAttribute('data-pagefly-sync-started', 'true');
          window.setTimeout(syncPageFlyComponent, 120, components[j]);
          window.setTimeout(syncPageFlyComponent, 350, components[j]);
          window.setTimeout(syncPageFlyComponent, 700, components[j]);
          window.setTimeout(syncPageFlyComponent, 1050, components[j]);
          window.setTimeout(function (component) {
            syncPageFlyComponent(component);
            component.removeAttribute('data-price-pending');
          }, 1250, components[j]);
        }
      }
    }

    window.PriceDynamicDiscount = {
      init: init,
      refreshAll: syncFromFormsAndUrl,
      updateByVariantId: updateByVariantId
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
